import { Navigate, useLocation } from "react-router-dom";
import { useProduct } from "@/lib/product-context";

/**
 * Redirects to the Klystic hub if no product has been selected yet.
 * Wraps the product-scoped app routes.
 */
export default function ProductGate({ children }) {
  const { product } = useProduct();
  const loc = useLocation();
  if (!product) {
    return <Navigate to="/" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
